import(/* webpackMode: "eager", webpackExports: ["withPageAuthRequired"] */ "/build/node_modules/@auth0/nextjs-auth0/dist/client/helpers/with-page-auth-required.js");
;
import(/* webpackMode: "eager", webpackExports: ["useUser"] */ "/build/node_modules/@auth0/nextjs-auth0/dist/client/hooks/use-user.js");
;
import(/* webpackMode: "eager", webpackExports: ["Auth0Provider"] */ "/build/node_modules/@auth0/nextjs-auth0/dist/client/providers/auth0-provider.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/@mui/material/Container/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["AvatarMenuButton"] */ "/build/src/components/navigation/appbar/AvatarMenuButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KAppBar"] */ "/build/src/components/navigation/appbar/KAppBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KnowledgeCenterIconButton"] */ "/build/src/components/navigation/appbar/KnowledgeCenterIconButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeftNavDrawerToggleButton"] */ "/build/src/components/navigation/appbar/LeftNavDrawerToggleButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationBellInboxButton"] */ "/build/src/components/navigation/appbar/NotificationBellInboxButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RenderIfUser"] */ "/build/src/components/navigation/RenderIfUser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeftNavDrawerMenu"] */ "/build/src/components/page/PageNavDrawer.tsx");
